var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.063 6.094v5.281H5.28V6.094h2.44v5.281h1.218V6.094h2.438v5.281H12a1 1 0 011 1V13H0v-.625a1 1 0 011-1h.625V6.094h2.438zM6.5 0c3.803 2.09 5.835 3.21 6.094 3.359a.813.813 0 01-.422 1.516H.828a.812.812 0 01-.422-1.516C.666 3.209 2.696 2.089 6.5 0z",
    id: "bank-a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-653-167H627V961H-653z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "bank-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bank-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#bank-a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bank-b)",
    fill: "#2B2D50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13v13H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank_icon.3f5464d53c091c76e5988a14f97f36b1.svg";
export { ForwardRef as ReactComponent };